import { iconDefaultDeskBookingArr } from "../../const/DefaultIconDeskBooking"


export default function setIconToPathDisponibilita (index) {

    let icon = iconDefaultDeskBookingArr[index]

    return icon
}